<div class="py-4 text-center">
  <h1>
    <a class="color-gray" [attr.data-test-id]="dataTestId + '-hint'"> {{ titleHint | translate }} </a>
    "<span class="text-primary cursor" [attr.data-test-id]="dataTestId" [routerLink]="[link, itemId]">{{ title }}</span
    >"
  </h1>
</div>
